module.exports = __webpack_public_path__ + "img/login-image.ff6ebd0a.png";